import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Paging from '../../component/Paging';
import request from '../../../utils/Request.utils';
import { formatYmd } from '../../../utils/Common.utils';
import { ToastContainer, toast } from 'react-toastify';
import Modal from '../../component/Modal';

const LIST_PAGE_SIZE = 10;
const formatNumber = (value) => Number(value || 0).toLocaleString();
const getBoardText = (value) => String(value || "");
/*
const getFaqCategoryLabel = (faq) => {
  const categoryName = faq.board_cate_comm_code?.code_nm_kr || faq.board_cate_comm_code?.code_nm || faq.board_cate || "-";
  return /^\d+$/.test(String(categoryName)) ? `분류 ${categoryName}` : categoryName;
};
*/
const Faq = ({ isLoggedIn }) => {
  const navigate = useNavigate();
  const [faqs, setFaqs] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currPage, setCurrPage] = useState(1);
  const [totalCnt, setTotalCnt] = useState(0);
  const [loading, setLoading] = useState(true);
  const [selectedFaqs, setSelectedFaqs] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const sortFaqs = (faqs) => {
    return faqs.sort((a, b) => new Date(b.reg_dtm) - new Date(a.reg_dtm));
  };

  const successHandler = useCallback((response) => {
    if (response.messageCode === 200) {
      const sortedFaqs = sortFaqs(response.data.dataList || []);
      setFaqs(sortedFaqs);
      setTotalPages(Number(response.data.tot_page) || 0);
      setTotalCnt(Number(response.data.totalCnt) || 0);
      setSelectedFaqs([]);
      setLoading(false);
    } else {
      toast.error("FAQ 정보를 불러올 수 없습니다.");
      setLoading(false);
    }
  }, []);

  const errorHandler = useCallback((error) => {
    toast.error("데이터를 불러오는 중 오류가 발생했습니다.");
    setLoading(false);
  }, []);

  const fetchFaqs = useCallback(() => {
    // 페이지를 옮기거나 다시 불러올 때는 표를 숨기지 않는다 — 숨겼다 다시 그리면 표·페이지 번호가 깜빡인다 (loading 은 첫 불러오기에만 true)
    const params = {
      curr_page: currPage,
      per_page: LIST_PAGE_SIZE,
      sort_col: 'reg_dtm',
      sort_by: 'desc',
      board_stat: 'all',
    };
    request.get("/board/list/admin/BD_FAQ", params, successHandler, errorHandler);
  }, [currPage, successHandler, errorHandler]);

  useEffect(() => {
    fetchFaqs();
  }, [currPage, fetchFaqs]);

  const handlePageChange = (page) => {
    setCurrPage(page);
  };

  const handleSelectFaq = (faqId) => {
    setSelectedFaqs(prevSelectedFaqs =>
      prevSelectedFaqs.includes(faqId)
        ? prevSelectedFaqs.filter(id => id !== faqId)
        : [...prevSelectedFaqs, faqId]
    );
  };

  const handleSelectAll = () => {
    if (faqs.length === 0) {
      setSelectedFaqs([]);
      return;
    }

    if (selectedFaqs.length === faqs.length) {
      setSelectedFaqs([]);
    } else {
      setSelectedFaqs(faqs.map(faq => faq.board_seq));
    }
  };

  const openModal = () => {
    if (selectedFaqs.length === 0) {
      toast.error("삭제할 FAQ를 선택해 주세요.");
      return;
    }
    setModalIsOpen(true);
  };
  const closeModal = () => setModalIsOpen(false);

  const handleDelete = async () => {
    if (selectedFaqs.length === 0) {
      toast.error("삭제할 FAQ를 선택해 주세요.");
      closeModal();
      return;
    }

    try {
      await request.del("/board/BD_FAQ", { board_seqs: selectedFaqs }, () => {
        toast.success("FAQ가 성공적으로 삭제되었습니다.");
        fetchFaqs();
        setSelectedFaqs([]);
      }, () => {
        toast.error("FAQ 삭제 중 오류가 발생했습니다.");
      });

    } catch (error) {
      console.log(error)
    } finally {
      closeModal();
    }
  };

  return (
    <main>
      <h2 className="adm_com_pg_tit">FAQ 목록</h2>
      <div className="adm_com_pg_content">
        <div className="adm_com_btn_wrap">
          <button className={`adm_com_btn ${selectedFaqs.length > 0 ? "blue" : "gray"}`} onClick={openModal} disabled={selectedFaqs.length === 0}>선택삭제</button>
          {/*<button onClick={() => navigate("/Board/Faq/Category")} className="adm_com_btn gray line">분류관리</button>*/}
          <button onClick={() => navigate("/Board/Faq/Write")} className="adm_com_btn black">추가</button>
        </div>
        {loading ? null : (
          <table className='adm_com_board_list'>
            <colgroup>
              <col width="5%" />
              <col width="5%" />
              <col width="20%" />
              {/*<col width="10%" />*/}
              <col width="35%" />
              <col width="10%" />
              <col width="10%" />
              <col width="7%" />
              <col width="8%" />
            </colgroup>
            <thead>
              <tr>
                <th>
                  <div className="check">
                    <input
                      type="checkbox"
                      id="chk01"
                      className="adm_com_chk"
                      onChange={handleSelectAll}
                      checked={faqs.length > 0 && selectedFaqs.length === faqs.length}
                      disabled={faqs.length === 0}
                    />
                    <label htmlFor="chk01" />
                  </div>
                </th>
                <th>번호</th>
                <th>질문</th>
                {/*<th>분류</th>*/}
                <th>답변</th>
                <th>작성자</th>
                <th>작성일자</th>
                <th>조회수</th>
                <th>관리</th>
              </tr>
            </thead>
            <tbody>
              {faqs.length === 0 && (
                <tr>
                  <td colSpan={8}>등록된 FAQ가 없습니다.</td>
                </tr>
              )}
              {faqs.map((faq, index) => (
                <tr key={faq.board_seq}>
                  <td>
                    <div className="check">
                      <input
                        type="checkbox"
                        id={`chk${index + 2}`}
                        className="adm_com_chk"
                        checked={selectedFaqs.includes(faq.board_seq)}
                        onChange={() => handleSelectFaq(faq.board_seq)}
                      />
                      <label htmlFor={`chk${index + 2}`} />
                    </div>
                  </td>
                  <td>{formatNumber(totalCnt - ((currPage - 1) * LIST_PAGE_SIZE + index))}</td>
                  <td className="notice_title_cell">
                    <span className="board_list_title" title={getBoardText(faq.board_title)}>
                      {getBoardText(faq.board_title)}
                    </span>
                  </td>
                  {/*<td>{getFaqCategoryLabel(faq)}</td>*/}
                  <td className="faq_answer_cell">
                    <span className="board_list_text" title={getBoardText(faq.board_content)}>
                      {getBoardText(faq.board_content)}
                    </span>
                  </td>
                  <td>{faq.author || '관리자'}</td>
                  <td>{formatYmd(faq.reg_dtm)}</td>
                  <td>{formatNumber(faq.board_hit)}</td>
                  <td className="board_action_cell">
                    <button onClick={() => navigate(`/Board/Faq/Write/${faq.board_seq}`)} className="adm_com_btn blue line">수정</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        {totalPages > 0 && <Paging currentPage={currPage} totalPages={totalPages} onPageChange={handlePageChange} />}
      </div>
      <Modal
        open={modalIsOpen}
        close={closeModal}
        type="confirm"
        popSize="s"
        title="삭제 확인"
        description="선택된 FAQ를 삭제하시겠습니까?"
      >
        <div className="btn_container">
          <button className="adm_com_btn blue" onClick={handleDelete}>삭제</button>
          <button className="adm_com_btn gray" onClick={closeModal}>취소</button>
        </div>
      </Modal>

      <ToastContainer />
    </main>
  );
};

export default Faq;
